import { Dispatch } from 'react'
import { ErrorActions, ErrorCodes } from '@constants/index'
import { Action } from '@reducers/detailsReducer'
import { setError } from './errorCodeActions'
import { RootState } from 'store'
import { setSkeleton } from './skeletonActions'
import { VelvetSDK } from 'sdk'
import { PageData } from 'sdk/services/cms/types/cmsService'

export const FETCH_MOVIE_REQUEST = 'FETCH_MOVIE_REQUEST' as const
export const FETCH_MOVIE_SUCCESS = 'FETCH_MOVIE_SUCCESS' as const
export const FETCH_MOVIE_FAILURE = 'FETCH_MOVIE_FAILURE' as const
export const RESET_MOVIE_DETAILS = 'RESET_MOVIE_DETAILS' as const

export const fetchMovieRequest = () => ({ type: FETCH_MOVIE_REQUEST })

export const fetchMovieSuccess = (movie: PageData) => ({
  type: FETCH_MOVIE_SUCCESS,
  payload: movie,
})

export const fetchMovieFailure = (error: string) => ({
  type: FETCH_MOVIE_FAILURE,
  payload: error,
})

export const fetchMovieDetails = (category: string, movieId: string, language?: string) => {
  return async (dispatch: Dispatch<Action>, getState: () => RootState) => {
    dispatch(fetchMovieRequest())
    dispatch(setSkeleton(true))
    const userCountry = getState().userCountry.data.countryCode
    const detailsData = await VelvetSDK.CMS.service().fetchDetails(category, movieId, false, language, userCountry)
    const errorFetchAction = getState().errorCode?.fetchAction

    if (!detailsData?.error) {
      dispatch(fetchMovieSuccess(detailsData))
      errorFetchAction === ErrorActions.DETAILS
        ? dispatch(setError({ errorCode: '', showErrorModal: false, movieId: movieId }))
        : dispatch(setError({ movieId: movieId }))
    } else {
      const errorUpdate = {
        showErrorModal: true,
        errorCode: ErrorCodes.FETCH_DETAIL_PAGE,
        HTTPcode: detailsData.error.status,
        fetchAction: ErrorActions.DETAILS,
        category: category,
        movieId: movieId,
      }

      const errorMsg = detailsData.error.message
      dispatch(fetchMovieFailure(errorMsg))
      dispatch(setError(errorUpdate))
    }
  }
}

export const resetMovieDetails = () => ({ type: RESET_MOVIE_DETAILS })
